var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"items-center h-8 px-2 text-base font-normal leading-normal text-gray-900 whitespace-no-wrap align-middle bg-gray-300 rounded-full cursor-pointer",class:_vm.isVisible ? 'inline-flex' : 'hidden'},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }